import { render, staticRenderFns } from "./DSAPartnerLayout.vue?vue&type=template&id=41191dae&scoped=true&"
import script from "./DSAPartnerLayout.vue?vue&type=script&lang=ts&"
export * from "./DSAPartnerLayout.vue?vue&type=script&lang=ts&"
import style0 from "./DSAPartnerLayout.vue?vue&type=style&index=0&id=41191dae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41191dae",
  null
  
)

export default component.exports